import PropTypes from 'prop-types'
import React from 'react'

import { isOrderItem } from '@/checkout-instore-legacy/returnExchange/utils'

import OrderItemCard from '../ItemCard/OrderItemCard'
import CatalogItemCard from '../ItemCard/CatalogItemCard'

export const ItemCardArray = ({
  items,
  showPrice,
  handleChangeItemQuantity,
  handleRemoveItem,
}) => {
  return items.map((item, index, array) => {
    const length = array.length
    return isOrderItem(item) ? (
      <OrderItemCard
        item={item}
        index={index}
        length={length}
        handleChangeItemQuantity={handleChangeItemQuantity}
        handleRemoveItem={handleRemoveItem}
        showPrice={showPrice}
        key={item.ean}
      />
    ) : (
      <CatalogItemCard
        item={item}
        ean={item.ean}
        index={index}
        length={length}
        handleChangeItemQuantity={handleChangeItemQuantity}
        handleRemoveItem={handleRemoveItem}
        showPrice={showPrice}
        key={item.ean}
      />
    )
  })
}

ItemCardArray.propTypes = {
  items: PropTypes.array,
  showPrice: PropTypes.bool,
  handleRemoveItem: PropTypes.func.isRequired,
  handleChangeItemQuantity: PropTypes.func.isRequired,
}

export default ItemCardArray
